export default __webpack_public_path__ + "static/media/support.c4ac66c5.png";